import externalLinks from './externalLinks';

export default externalLinks;
